export const COPY = {
  en: {
    seo: {
      title: "RockinHwelding.com | Welder in Firebaugh, CA — Gates, Fabrication & BBQ Smokers",
      description:
        "Rockin H Welding — family-owned welder in Firebaugh, CA. Custom fabrication, ranch gates & fencing, farm equipment repair and restored BBQ smokers across the Central Valley. Call or text Wade at (270) 743-7860 or email Rockinhweld@gmail.com.",
      keywords:
        "welder Firebaugh CA, custom gates Central Valley, farm equipment repair Fresno County, custom BBQ smoker California, mobile welding Mendota, welding Los Banos",
      locale: "en_US",
    },
    langLabel: "ES",
    langAria: "Ver el sitio en español",
    nav: { services: "Services", work: "Our Work", process: "How It Works", area: "Service Area", quote: "Get a Quote" },
    hero: {
      eyebrow: "Firebaugh, CA · Est. family-owned",
      h1a: "Built tough.",
      h1b: "Welded right.",
      sub: "Custom fabrication, ranch gates, farm repair and restored BBQ smokers. Wade Hill runs the torch — shop work or on-site anywhere in the Central Valley.",
      call: "Call Wade",
      text: "Text a photo",
      trust: ["Family-owned", "Firebaugh, CA", "Serving the Central Valley", "Call anytime"],
      scroll: "What we build",
    },
    services: {
      label: "What we do",
      title: "Five ways we put steel to work",
      sub: "From a snapped hitch pin to a full smoker trailer — if it's metal and it matters, it comes through the Rockin H shop.",
      badge: "New",
    },
    gallery: {
      label: "The proof",
      title: "Real jobs, real steel",
      sub: "Photos straight off the shop floor and out of the field. More going up as jobs roll out the door.",
      realBadge: "Real job",
      filters: {
        All: "All",
        Fabrication: "Fabrication",
        Gates: "Gates",
        Smokers: "Smokers",
        Repair: "Repair",
        "Kids Builds": "Kids Builds",
        Other: "Other",
      },
    },
    process: { label: "How it works", title: "Four steps. No runaround." },
    area: {
      label: "Service area",
      title: "Firebaugh and the whole Valley",
      sub: "Based in Firebaugh, CA. The welding rig travels — if you're within a reasonable haul, Wade will come to you.",
      mapTitle: "Rockin H Welding service area map centered on Firebaugh, California",
    },
    testimonials: {
      label: "Word around the valley",
      title: "What folks say",
      sub: "Fresh reviews are being collected. Worked with Wade? Text him a line and it'll land right here.",
      cta: "Text Wade a review",
      name: "Customer name",
      quote: "Placeholder — real customer quote coming soon.",
    },
    quote: {
      label: "Get a quote",
      title: "Tell Wade what you need",
      sub: "Fill this out and it goes straight to Wade's phone. Prefer talking? Call or text — that works too.",
      textBtn: "Text a photo",
      emailBtn: "Email Wade",
      nameLabel: "Your name",
      namePh: "Wade Hill",
      phoneLabel: "Phone number",
      phonePh: "(559) 555-0134",
      jobLabel: "Describe the job",
      jobPh: "Cracked hitch on a disc, need it welded this week. Out past Mendota.",
      photoNote: "Got a photo? Text it to",
      photoNoteEnd: "after you send this.",
      submit: "Send it to Wade",
      sending: "Sending…",
      doneTitle: "Wade got it — he'll text you back shortly.",
      doneBody: "Usually same day. If it's urgent, call",
      doneBodyEnd: "and he'll pick up if he's not under a hood.",
      reset: "Send another job",
      errValidation: "Need a name, a working phone number, and a quick note on the job.",
      errSend: "Couldn't send that. Give Wade a call at",
    },
    footer: {
      callOrText: "Call or text Wade",
      tapCall: "Tap to call",
      tapText: "Tap to text",
      shop: "The shop",
      shopVal: "Firebaugh, California 93622",
      hours: "Hours",
      hoursVal: "Call anytime / by appointment",
      email: "Email",
      area: "Service area",
      google: "Find us on Google",
    },
    towns: {},
  },

  es: {
    seo: {
      title: "RockinHwelding.com | Soldador en Firebaugh, CA — Portones, Fabricación y Asadores BBQ",
      description:
        "Rockin H Welding — soldador familiar en Firebaugh, CA. Fabricación a medida, portones y cercas para rancho, reparación de equipo agrícola y asadores BBQ restaurados en todo el Valle Central. Llame o mande mensaje a Wade al (270) 743-7860 o escriba a Rockinhweld@gmail.com.",
      keywords:
        "soldador en Firebaugh CA, soldadura Valle Central, portones de rancho a medida, reparación de equipo agrícola Condado de Fresno, asador BBQ a medida California, soldadura a domicilio Mendota, soldador Los Banos, herrería Firebaugh",
      locale: "es_US",
    },
    langLabel: "EN",
    langAria: "View this site in English",
    nav: { services: "Servicios", work: "Trabajos", process: "Cómo Funciona", area: "Zona de Servicio", quote: "Cotización" },
    hero: {
      eyebrow: "Firebaugh, CA · Negocio familiar",
      h1a: "Hecho fuerte.",
      h1b: "Soldado bien.",
      sub: "Fabricación a medida, portones para rancho, reparación agrícola y asadores BBQ restaurados. Wade Hill maneja la soldadora — en el taller o a domicilio en todo el Valle Central.",
      call: "Llame a Wade",
      text: "Mande una foto",
      trust: ["Negocio familiar", "Firebaugh, CA", "Servimos el Valle Central", "Llame a cualquier hora"],
      scroll: "Lo que hacemos",
    },
    services: {
      label: "Qué hacemos",
      title: "Cinco maneras de trabajar el acero",
      sub: "Desde un pasador roto hasta un asador completo con remolque — si es metal y le importa, pasa por el taller Rockin H.",
      badge: "Nuevo",
    },
    gallery: {
      label: "La prueba",
      title: "Trabajos reales, acero real",
      sub: "Fotos directas del taller y del campo. Subimos más conforme salen los trabajos.",
      realBadge: "Trabajo real",
      filters: {
        All: "Todo",
        Fabrication: "Fabricación",
        Gates: "Portones",
        Smokers: "Asadores",
        Repair: "Reparación",
        "Kids Builds": "Para Niños",
        Other: "Otros",
      },
    },
    process: { label: "Cómo funciona", title: "Cuatro pasos. Sin vueltas." },
    area: {
      label: "Zona de servicio",
      title: "Firebaugh y todo el Valle",
      sub: "Con base en Firebaugh, CA. La soldadora viaja — si está a una distancia razonable, Wade llega a su propiedad.",
      mapTitle: "Mapa de la zona de servicio de Rockin H Welding centrado en Firebaugh, California",
    },
    testimonials: {
      label: "Lo que se dice en el valle",
      title: "Lo que dicen los clientes",
      sub: "Estamos juntando reseñas nuevas. ¿Trabajó con Wade? Mándele un mensaje y aparecerá aquí.",
      cta: "Mande su reseña a Wade",
      name: "Nombre del cliente",
      quote: "Espacio reservado — pronto una reseña real de un cliente.",
    },
    quote: {
      label: "Cotización",
      title: "Dígale a Wade qué necesita",
      sub: "Llene esto y llega directo al teléfono de Wade. ¿Prefiere hablar? Llame o mande mensaje — también funciona.",
      textBtn: "Mande una foto",
      emailBtn: "Correo a Wade",
      nameLabel: "Su nombre",
      namePh: "Juan Hernández",
      phoneLabel: "Número de teléfono",
      phonePh: "(559) 555-0134",
      jobLabel: "Describa el trabajo",
      jobPh: "Se quebró el engancho de una rastra, la necesito soldada esta semana. Pasando Mendota.",
      photoNote: "¿Tiene una foto? Mándela al",
      photoNoteEnd: "después de enviar esto.",
      submit: "Enviar a Wade",
      sending: "Enviando…",
      doneTitle: "Wade lo recibió — le manda mensaje en breve.",
      doneBody: "Casi siempre el mismo día. Si es urgente, llame al",
      doneBodyEnd: "y contesta si no está debajo de una máquina.",
      reset: "Enviar otro trabajo",
      errValidation: "Necesitamos su nombre, un teléfono válido y una nota corta del trabajo.",
      errSend: "No se pudo enviar. Llame a Wade al",
    },
    footer: {
      callOrText: "Llame o mande mensaje a Wade",
      tapCall: "Toque para llamar",
      tapText: "Toque para textear",
      shop: "El taller",
      shopVal: "Firebaugh, California 93622",
      hours: "Horario",
      hoursVal: "Llame a cualquier hora / con cita",
      email: "Correo electrónico",
      area: "Zona de servicio",
      google: "Búsquenos en Google",
    },
    towns: { "Fresno County": "Condado de Fresno" },
  },
};
